import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TKubunListGetRes,
  TKubunListGetReq,
  TMasterKubunRegisterPostReq,
  TMasterKubunListItem,
  TMasterKubunRegisterPutReq,
  TKubunBunruiPutReq,
  TKubunPutReq,
  TKubunBunruiInfoRes,
} from "./TKubun"

/**
 * 社員マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class KubunService
 * @extends {ConnectApi}
 */
export default class KubunService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TKubunListGetReq} params
   * @memberof MenuService
   */
  getList = async (params?: TKubunListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKubunListGetRes[]>> =
        await this.getInner(`/master/kubun`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 区分マスタ一覧検索取得
   *
   * @param {TKubunListGetReq} params
   * @param {(param: TApiResponse<TKubunBunruiInfoRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKubunBunruiInfoRes>>) => any} reject
   * @memberof MenuService
   */
  getKubunBunruiList = async (params?: TKubunListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKubunBunruiInfoRes[]>> =
        await this.getInner(`/master/kubun/kubunbunrui/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TMasterKubunListItem>> =
        await this.getInner(`master/kubun/register/${id}`, signal)
      return res.data

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TMasterKubunRegisterPostReq} data
   * @param {(param: TApiResponse<TKubunListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKubunListGetRes>>) => any} reject
   * @memberof KubunService
   */
  post = async (data: TMasterKubunRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/master/kubun/register/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TMasterKubunRegisterPutReq} data
   * @param {(param: TApiResponse<TKubunListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKubunListGetRes>>) => any} reject
   * @memberof KubunService
   */
  put = async (
    id: number,
    data: TMasterKubunRegisterPutReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/master/kubun/register/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 区分分類更新
   *
   * @param {TKubunBunruiPutReq} data
   * @param {(param: TApiResponse<TKubunListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKubunListGetRes>>) => any} reject
   * @memberof KubunService
   */
  kubunBunruiPut = async (
    id: number,
    data: TKubunBunruiPutReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/master/kubun/register/kubunbunruiput/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 区分更新
   *
   * @param {TKubunPutReq} data
   * @param {(param: TApiResponse<TKubunListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKubunListGetRes>>) => any} reject
   * @memberof KubunService
   */
  kubunPut = async (id: number, data: TKubunPutReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/master/kubun/register/kubunput/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
